// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalogList-modulelist__y3znB";
export { _1 as "list" }
